module.exports = __webpack_public_path__ + "images/external_images/img/900x450/img6.jpg";